import React, { useState } from 'react';

import AssetLibrary from '../../../../shared/components/AssetLibrary/AssetLibrary';
import AssetService from '../../../../shared/services/AssetService';
import CancelIcon from '@mui/icons-material/Cancel';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import ImageIcon from '@mui/icons-material/Image';
import { InlineQuillEdit } from '../../InlineQuillEdit';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import styles from '../../../styles/FlipCard.module.scss';

interface FlipItemEditorProps {
  title: string;
  label: string;
  componentkey: number;
  assetkey: string;
  handleTextChange: (value: string) => void;
  handleAssetSelect: (assetkey: string) => void;
  handleRemoveImage: () => void;
}

/** Custom size CancelIcon */
export const CustomCancelIcon = styled(CancelIcon)({
  fontSize: '15px',
  '&.MuiSvgIcon-root': {
    fontSize: '15px'
  }
});

export default function FlipItemEditor(props: FlipItemEditorProps) {
  const {
    title,
    label,
    componentkey,
    assetkey,
    handleTextChange,
    handleAssetSelect,
    handleRemoveImage
  } = props;

  const src = AssetService.getAssetUrl(assetkey);

  const [showAssetLibrary, setShowAssetLibrary] = useState(false);

  return (
    <>
      <Grid>
        <Typography className={styles.typography}>{`Card ${title}`}</Typography>
      </Grid>
      <Grid>
        <Grid container alignItems="center">
          <Grid className={styles.gridStretch}>
            <InlineQuillEdit
              placeholder={
                label || assetkey
                  ? `Click to edit item text for the ${title} of the card`
                  : `Click to add item text for the ${title} of the card`
              }
              value={label || ''}
              componentKey={componentkey}
              styleType="noList"
              onChange={handleTextChange}
            />
          </Grid>

          <Grid style={{ position: 'relative' }}>
            {src ? (
              <>
                <img
                  className={styles.itemEditorThumbnail}
                  src={src}
                  onClick={() => {
                    setShowAssetLibrary(true);
                  }}
                />
                <div className={styles.customCancelIcon}>
                  <IconButton onClick={handleRemoveImage}>
                    <CustomCancelIcon />
                  </IconButton>
                </div>
              </>
            ) : (
              <IconButton
                size="small"
                onClick={() => {
                  setShowAssetLibrary(true);
                }}
              >
                <ImageIcon />
              </IconButton>
            )}
          </Grid>
        </Grid>
      </Grid>
      {showAssetLibrary && (
        <AssetLibrary
          types={['image']}
          category="author"
          title="Select Image"
          selectedAssetkey={assetkey}
          onSelect={handleAssetSelect}
          onClose={() => setShowAssetLibrary(false)}
        />
      )}
    </>
  );
}
